"use client";

import useModal from "@/hooks/useModal";
import { Slot } from "@frend-digital/ui";
import { ComponentProps, Suspense } from "react";

const UnsuspendedGeoSelectorTrigger = ({
  asChild,
  ...props
}: Exclude<ComponentProps<"button">, "onClick"> & {
  asChild?: boolean;
}) => {
  const { openModal } = useModal("geo");

  const Component = asChild ? Slot : "button";
  return <Component onClick={openModal} {...props} />;
};

export const GeoSelectorTrigger: typeof UnsuspendedGeoSelectorTrigger = ({
  children,
  ...props
}) => {
  return (
    <Suspense fallback={props.asChild ? children : null}>
      <UnsuspendedGeoSelectorTrigger {...props}>
        {children}
      </UnsuspendedGeoSelectorTrigger>
    </Suspense>
  );
};
